/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export function isNotNil<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export function isNil<TValue>(value: TValue | null | undefined): value is null | undefined {
  return !isNotNil(value);
}
